import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import CapitalHero from "@/components/proposal/CapitalHero";
import CapitalContent from "@/components/proposal/CapitalContent";

const Index = () => {
  return (
    <main className="min-h-screen bg-background">
      <Navbar />
      <CapitalHero />
      <CapitalContent />
      <Footer />
    </main>
  );
};

export default Index;
